import { AnyAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CommissionLedgerResponse {
  page: number;
  page_size: number;
  total: number;
  data: AnyAction[];
  summary?: {
    label: string;
    value: number;
  }[];
}

type CommissionFilterOption = {
  id: string | number;
  name: string;
  is_active?: boolean;
};

interface CommissionLedgerState {
  commissionRecords: CommissionLedgerResponse;
  statuses?: CommissionFilterOption[];
  insurers?: CommissionFilterOption[];
  dateRanges?: CommissionFilterOption[];
}

const initialState: CommissionLedgerState = {
  commissionRecords: {
    page: 1,
    page_size: 10,
    total: 0,
    data: [],
  },
  statuses: [],
  insurers: [],
  dateRanges: [],
};

const commissionLedgerSlice = createSlice({
  name: "commissionLedger",
  initialState,
  reducers: {
    setCommissionRecords: (state, action: PayloadAction<CommissionLedgerResponse>) => {
      state.commissionRecords = action.payload;
    },
    setCommissionStatuses: (state, action: PayloadAction<any>) => {
      state.statuses = action.payload?.data || action.payload || [];
    },
    setCommissionInsurer: (state, action: PayloadAction<any>) => {
      const insurers = action.payload?.data || action.payload || [];

      state.insurers = Array.isArray(insurers)
        ? insurers.filter((insurer: CommissionFilterOption) => insurer.is_active === true)
        : [];
    },
    setCommissionDateRange: (state, action: PayloadAction<any>) => {
      state.dateRanges = action.payload?.data || action.payload || [];
    },
  },
});

export const {
  setCommissionRecords,
  setCommissionStatuses,
  setCommissionInsurer,
  setCommissionDateRange,
} = commissionLedgerSlice.actions;
export const { reducer: commissionLedgerReducer } = commissionLedgerSlice;
